<template>
  <qx-card-form title="收货信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span slot="desAddressNameTip" class="fix-position">
        <span class="primary cur" @click="toAddNewAddress">新增</span>
      </span>
      <section slot="quantityShipped" slot-scope="prop">
        <el-input
          v-model="prop.form.quantityShipped"
          class="inputBox"
          placeholder="请输入数量"
        >
          <el-select
            class="inputAppendSelect"
            slot="suffix"
            v-model="otherFormData.quantityShippedUnit"
            :clear="true"
          >
            <!-- 单位 -->
            <el-option
              v-for="item in quantityShippedUnitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </section>
      <section slot="squareAndWeight">
        <el-input
          class="appendInputBox"
          v-model="otherFormData.productVolume"
          placeholder="体积"
        >
          <span slot="suffix">
            <span class="unit">立方</span>
            <el-input
              class="inputAppendInput"
              v-model="otherFormData.productWeight"
              :clear="true"
              placeholder="重量"
            >
              <span class="unit" slot="suffix">吨</span>
            </el-input>
          </span>
        </el-input>
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  queryConsignee,
  cityAddressQueryPage,
} from 'api/distribution';
import {
  selectSysStaticDataByCodeType,
} from 'api';
export default {
  data () {
    return {
      quantityShippedUnitOptions: [],
      otherFormData: {
        quantityShippedUnit: '1',
        productVolume: '',
        productWeight: '',
      },
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '目的地名称',
            value: 'desAddressName',
            placeholder: '请输入目的地名称',
            type: 'el-autocomplete',
            valueKey: 'addressName',
            querySearchAsync: (queryString, cb) => {
              let resInfo = [];
              if (queryString && queryString.length) {
                cityAddressQueryPage({
                  rows: 10000,
                  addressType: 1,
                }).then((res) => {
                  if (res && res.items && res.items.length) {
                    resInfo = res.items.filter((item) => item.addressName.includes(queryString));
                  }
                  cb(resInfo);
                });
              } else {
                cityAddressQueryPage({
                  rows: 10000,
                  addressType: 1,
                }).then((res) => {
                  if (res && res.items && res.items.length) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
            },
            onSelect: async (item) => {
              if (item) {
                this.$refs.baseForm.setVal('desAddressDtl', item.addressDtl);
                this.$refs.baseForm.setVal('consignee', item.consignee);
              }
            },
          },
          {
            label: '收货方',
            value: 'consignee',
            type: 'el-autocomplete',
            disabled: true,
            querySearchAsync: (queryString, cb) => {
              let resInfo = [];
              if (queryString && queryString.length) {
                queryConsignee({
                  value: queryString,
                }).then((res) => {
                  if (res && res.length) {
                    resInfo = res.map((item) => ({
                      value: item,
                    }));
                  }
                  cb(resInfo);
                });
              } else {
                cb(resInfo);
              }
            },
          },
          {
            label: '详细地址',
            value: 'desAddressDtl',
            placeholder: '请输入详细地址',
            type: 'input',
            // disabled: true,
          },
          {
            label: '数量',
            value: 'quantityShipped',
            slot: true,
          },
          {
            label: '货物名称',
            value: 'productName',
            placeholder: '请输入货物名称',
            type: 'input',
          },
          {
            label: '体积重量',
            value: 'squareAndWeight',
            slot: true,
          },
          {
            label: '要求到达',
            value: 'requiredTime',
            placeholder: '请输入要求到达时间',
            type: 'input',
            unit: '小时',
            remark: '从提货时间开始计算',
          },
        ],
        rules: {
          desAddressName: [
            { required: true, message: '请输入目的地名称', trigger: 'submit' },
          ],
          desAddressDtl: [
            { required: true, message: '请输入详细地址', trigger: 'blur' },
          ],
          quantityShipped: [
            { required: true, message: '请输入数量', trigger: 'blur' },
          ],
          requiredTime: [
            { required: true, message: '请输入要求到达时间', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      const formData = await this.sub();
      console.log(formData);
    },

    async getOptions () {
      const quantityShippedUnitOptions = await selectSysStaticDataByCodeType({
        codeType: 'QUANTITY_SHIPPED_UNIT',
        hasAll: true,
      });
      this.quantityShippedUnitOptions = quantityShippedUnitOptions.filter((item) => item.value !== '-1');
    },

    toAddNewAddress () {
      this.$emit('toAddNewAddress', '1');
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();

      if (data.quantityShippedUnit === undefined || data.quantityShippedUnit === null) {
        if (this.quantityShippedUnitOptions.length) {
          data.quantityShippedUnit = this.quantityShippedUnitOptions[0].value;
        }
      } else {
        data.quantityShippedUnit = String(data.quantityShippedUnit);
      }

      this.otherFormData.quantityShippedUnit = data.quantityShippedUnit || '';
      this.otherFormData.productVolume = data.productVolume || '';
      this.otherFormData.productWeight = data.productWeight || '';

      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.fix-position {
  position: relative;
  z-index: 1;
  .cur {
    position: absolute;
    left: 8px;
    white-space: nowrap;
  }
}
</style>
